// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export const labels = {
  CLUSTER_NAME: 'cluster.name',
  // Was this for a new keystore or an existing private key?
  CREATE_KEYSTORE_NEW: 'create.keystore.new',
  // Differentiates click locations
  CLICK_SOURCE: 'click.source',
  // React component stack
  COMPONENT_STACK: 'react.component_stack',
  // Websocket related properties
  WEBSOCKET_URL: 'websocket.url',
  WEBSOCKET_CLOSE_CODE: 'websocket.close.code',
  WEBSOCKET_CLOSE_REASON: 'websocket.close.reason',
  WEBSOCKET_MESSAGE_TYPE: 'websocket.message.type',
  WEBSOCKET_MESSAGE_JSON: 'websocket.message_json',
  WEBSOCKET_PROTOCOLS: 'websocket.protocols',
  // GraphQL related propreties
  GRAPHQL_QUERY: 'graphql.query',
  GRAPHQL_VARIABLES: 'graphql.variables',
  GRAPHQL_LIVE_NAME: 'graphql.live.name',
  GRAPHQL_PATH: 'graphql.path',
  // User agent
  UA: 'ua.raw',
  UA_BROWSER_NAME: 'ua.browser.name',
  UA_BROWSER_VERSION: 'ua.browser.version',
  UA_DEVICE_MODEL: 'ua.device.model',
  UA_DEVICE_TYPE: 'ua.device.type',
  UA_DEVICE_VENDOR: 'ua.device.vendor',
  UA_ENGINE_NAME: 'ua.engine.name',
  UA_ENGINE_VERSION: 'ua.engine.version',
  UA_OS_NAME: 'ua.os.name',
  UA_OS_VERSION: 'ua.os.version',
  UA_CPU_ARCHITECTURE: 'ua.cpu.architecture',
  // App version
  APP_VERSION: 'app.version',
  // Client side stack capture
  STACK_MESSAGE: 'client_error.stack.message',
  STACK_LINENUMBER: 'client_error.stack.line_number',
  STACK_COLUMNNUMBER: 'client_error.stack.column_number',
  // Kubernetes
  POD_NAME: 'pod.name',
  // LetsEncrypt
  LETSENCRYPT_DOMAINS: 'lets_encrypt.domains',
  LETSENCRYPT_NAMESPACE: 'lets_encrypt.namespace',
  LETSENCRYPT_SECRET: 'lets_encrypt.secret',
  LETSENCRYPT_HOSTNAME: 'lets_encrypt.hostname',
  // DNS
  DNS_ID: 'dns.id',
  DNS_ADD: 'dns.add',
  DNS_DELETE: 'dns.delete',
  DNS_SERVICE_KEY: 'dns.service.key',
  DNS_SERVICE_RECORDS: 'dns.service.records',
  DNS_SERVICE_DELETE: 'dns.service.delete',
  DNS_NODE_RECORDS: 'dns.node.records',
  // Postgres
  POSTGRES_BACKUPWAL_ISBEHIND: 'postgres.backup_wal.is_behind',
  POSTGRES_BACKUPWAL_VALUE: 'postgres.backup_wal.value',
  POSTGRES_BACKUPWAL_LSNOFFSET: 'postgres.backup_wal.lsn_offset',
  POSTGRES_BACKUPWAL_REDOWAL: 'postgres.backup_wal.redo_wal',
  POSTGRES_BACKUPWAL_REDOWALLSN: 'postgres.backup_wal.redo_wal_lsn',
  POSTGRES_DATAEXIST: 'postgres.data_exist',
  POSTGRES_BACKUPEXIST: 'postgres.backup_exist',
  POSTGRES_ONSAMETIMELINE: 'postgres.on_same_timeline',
  POSTGRES_EXIT_CODE: 'postgres.exit.code',
  POSTGRES_EXIT_SIGNAL: 'postgres.exit.signal',
  POSTGRES_LOG_FILE: 'postgres.log.file',
  POSTGRES_REMOTEWALFILE: 'postgres.remote_walfile',
  // Process
  EXEC_COMMAND: 'exec.command',
  EXEC_ARGS: 'exec.args',
  // General
  QUEUE_SIZE: 'queue.size',
  OPTIONS: 'options',
  // Database
  DB_TABLE: 'db.table',
};

// eslint-disable-next-line no-shadow
export enum Labels {
  SERVICE = 'service',
  COMPONENT = 'component',
  // Database instance name. E.g. main
  DB_INSTANCE = 'db.instance',
  // Database statement. E.g. SELECT * FROM wuser table;
  DB_STATEMENT = 'db.statement',
  // Database type. For any SQL database, "sql". For others, the lower-case
  // database category, e.g. "cassandra", "hbase", or "redis".
  DB_TYPE = 'db.type',
  // Username for accessing database. E.g., "readonly_user" or "reporting_user"
  DB_USER = 'db.user',
  // Database filename. For sqlite or other database systems with a file based
  DB_FILENAME = 'db.filename',
  // true if and only if the application considers the operation to have failed
  ERROR = 'error',
  // Error code if available or constructor name
  ERROR_KIND = 'error.kind',
  // Actual Error object
  ERROR_OBJECT = 'error.object',
  // Error stack
  ERROR_STACK = 'stack',
  // HTTP method of the request for the associated Span. E.g., "GET", "POST"
  HTTP_METHOD = 'http.method',
  // HTTP response status code for the associated Span. E.g., 200, 503, 404
  HTTP_STATUS_CODE = 'http.status_code',
  // URL of the request being handled in this segment of the trace, in standard
  // URI format. E.g., "https://domain.net/path/to?resource=here"
  HTTP_URL = 'http.url',
  // An address at which messages can be exchanged. E.g. A Kafka record has an
  // associated "topic name" that can be extracted by the instrumented producer
  // or consumer and stored using this tag.
  MESSAGE_BUS_DESTINATION = 'message_bus.destination',
  // Remote "address", suitable for use in a networking client library. This may
  // be a "ip:port", a bare "hostname", a FQDN, or even a JDBC substring like
  // "mysql://prod-db:3306"
  PEER_ADDRESS = 'peer.address',
  // Remote hostname. E.g., "opentracing.io", "internal.dns.name"
  PEER_HOSTNAME = 'peer.hostname',
  // Remote IPv4 address as a .-separated tuple. E.g., "127.0.0.1"
  PEER_IPV4 = 'peer.ipv4',
  // Remote IPv6 address as a string of colon-separated 4-char hex tuples.
  // E.g., "2001:0db8:85a3:0000:0000:8a2e:0370:7334"
  PEER_IPV6 = 'peer.ipv6',
  // Remote port. E.g., 80
  PEER_PORT = 'peer.port',
  // Remote service name (for some unspecified definition of "service").
  // E.g., "elasticsearch", "a_custom_microservice", "memcache"
  PEER_SERVICE = 'peer.service',
  // If greater than 0, a hint to the Tracer to do its best to capture the
  // trace. If 0, a hint to the trace to not-capture the trace. If absent,
  // the Tracer should use its default sampling mechanism.
  SAMPLING_PRIORITY = 'sampling.priority',
  // Either "client" or "server" for the appropriate roles in an RPC, and
  // "producer" or "consumer" for the appropriate roles in a messaging scenario.
  SPAN_KIND = 'span.kind',
  // Low cardinality version of db.statement
  DB_STATEMENT_SUMMARY = 'db.statement.summary',
  // The path of the request. Must be low cardinality. E.g. /account/:id
  // not /account/123
  HTTP_PATH = 'http.path',
  // Full path of the request, high cardinality.
  HTTP_FULLPATH = 'http.full_path',
  // The user agent for the request.
  HTTP_USER_AGENT = 'http.user_agent',
  // Request length
  HTTP_REQUEST_SIZE = 'http.request.size',
  // Headers
  HTTP_HEADERS = 'http.headers',
  // Request protocol
  HTTP_REQUEST_PROTOCOL = 'http.request.protocol',
  // Request querystring
  HTTP_REQUEST_QUERY = 'http.request.query',
  // RPC method called. E.g. getblock.
  RPC_METHOD = 'rpc.method',
  // RPC type, e.g. jsonrpc.
  RPC_TYPE = 'rpc.type',
  PLUGIN_NAME = 'plugin.name',
  RESOURCETYPE_NAME = 'resource_type.name',
  COMMAND_NAME = 'command.name',
  CLUSTER_NAME = 'cluster.name',
  CLICK_SOURCE = 'click.source',
  COMPONENT_STACK = 'react.component_stack',
  WEBSOCKET_URL = 'websocket.url',
  WEBSOCKET_CLOSE_CODE = 'websocket.close.code',
  WEBSOCKET_CLOSE_REASON = 'websocket.close.reason',
  WEBSOCKET_MESSAGE_TYPE = 'websocket.message.type',
  WEBSOCKET_MESSAGE_JSON = 'websocket.message_json',
  WEBSOCKET_PROTOCOLS = 'websocket.protocols',
  GRAPHQL_QUERY = 'graphql.query',
  GRAPHQL_VARIABLES = 'graphql.variables',
  GRAPHQL_LIVE_NAME = 'graphql.live.name',
  GRAPHQL_PATH = 'graphql.path',
  UA = 'ua.raw',
  UA_BROWSER_NAME = 'ua.browser.name',
  UA_BROWSER_VERSION = 'ua.browser.version',
  UA_DEVICE_MODEL = 'ua.device.model',
  UA_DEVICE_TYPE = 'ua.device.type',
  UA_DEVICE_VENDOR = 'ua.device.vendor',
  UA_ENGINE_NAME = 'ua.engine.name',
  UA_ENGINE_VERSION = 'ua.engine.version',
  UA_OS_NAME = 'ua.os.name',
  UA_OS_VERSION = 'ua.os.version',
  UA_CPU_ARCHITECTURE = 'ua.cpu.architecture',
  APP_VERSION = 'app.version',
  STACK_MESSAGE = 'client_error.stack.message',
  STACK_LINENUMBER = 'client_error.stack.line_number',
  STACK_COLUMNNUMBER = 'client_error.stack.column_number',
  POD_NAME = 'pod.name',
  LETSENCRYPT_DOMAINS = 'lets_encrypt.domains',
  LETSENCRYPT_NAMESPACE = 'lets_encrypt.namespace',
  LETSENCRYPT_SECRET = 'lets_encrypt.secret',
  LETSENCRYPT_HOSTNAME = 'lets_encrypt.hostname',
  DNS_ID = 'dns.id',
  DNS_ADD = 'dns.add',
  DNS_DELETE = 'dns.delete',
  DNS_SERVICE_KEY = 'dns.service.key',
  DNS_SERVICE_RECORDS = 'dns.service.records',
  DNS_SERVICE_DELETE = 'dns.service.delete',
  DNS_NODE_RECORDS = 'dns.node.records',
  POSTGRES_BACKUPWAL_ISBEHIND = 'postgres.backup_wal.is_behind',
  POSTGRES_BACKUPWAL_VALUE = 'postgres.backup_wal.value',
  POSTGRES_BACKUPWAL_LSNOFFSET = 'postgres.backup_wal.lsn_offset',
  POSTGRES_BACKUPWAL_REDOWAL = 'postgres.backup_wal.redo_wal',
  POSTGRES_BACKUPWAL_REDOWALLSN = 'postgres.backup_wal.redo_wal_lsn',
  POSTGRES_DATAEXIST = 'postgres.data_exist',
  POSTGRES_BACKUPEXIST = 'postgres.backup_exist',
  POSTGRES_ONSAMETIMELINE = 'postgres.on_same_timeline',
  POSTGRES_EXIT_CODE = 'postgres.exit.code',
  POSTGRES_EXIT_SIGNAL = 'postgres.exit.signal',
  POSTGRES_LOG_FILE = 'postgres.log.file',
  POSTGRES_REMOTEWALFILE = 'postgres.remote_walfile',
  EXEC_COMMAND = 'exec.command',
  EXEC_ARGS = 'exec.args',
  QUEUE_SIZE = 'queue.size',
  OPTIONS = 'options',
  DB_TABLE = 'db.table',
}
